import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CurrentUserService } from '../auth/current-user.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  constructor(
    private readonly currentUserService: CurrentUserService,
    private readonly translateService: TranslateService
  ) {}

  private generateUUID(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      try {
        return crypto.randomUUID();
      } catch (e) {
        // Crypto API failed, check environment
      }
    }
    
    if (environment.env === 'dev' || environment.env === 'local') {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
    
    // Staging/Production: Require secure context
    throw new Error(
      `UUID generation requires secure context (HTTPS). ` +
      `Current environment '${environment.env}' does not allow fallback UUID generation.`
    );
  }

  getHeaders(): HttpHeaders {
    const currentUser = this.currentUserService.GetSession();

    const contentLanguage =
      localStorage.getItem('app-lang') ||
      this.translateService.currentLang ||
      this.translateService.getDefaultLang?.() ||
      (typeof navigator !== 'undefined' ? navigator.language : undefined) ||
      'en-US';

    const headers = new HttpHeaders({
      Authorization: `Bearer ${currentUser?.token}`,
      'X-Application-Code': 'SORE',
      'Content-Language': contentLanguage,
      'X-Correlation-Id': currentUser?.correlationId || this.generateUUID(),
    });
    return headers;
  }

  getHeadersWithoutAuth(): HttpHeaders {
    const contentLanguage =
      localStorage.getItem('app-lang') ||
      this.translateService.currentLang ||
      this.translateService.getDefaultLang?.() ||
      (typeof navigator !== 'undefined' ? navigator.language : undefined) ||
      'en-US';

    const headers = new HttpHeaders({
      'X-Application-Code': 'SORE',
      'Content-Language': contentLanguage,
      'X-Correlation-Id': this.generateUUID(),
    });
    return headers;
  }
}
